<template>
    <div class="validation-errors">
        <div class="validation-errors__field" v-for="(error, key) in errorsList.errors">
            <div class="validation-errors__field--value"
                 v-for="error_text in error"
                 :class="{ 'large-error': isErrorLarge(key, error) }">
                <template v-if="(key != 'ptc') && (key != 'bonus_invalid')">
                    {{error_text}}
                </template>
            </div>
        </div>
        <div class="validation-errors__field" v-if="errorsList.errors && isVehicleErrors && !isDealer() && !isMutuaide() && !monthly">
            <div class="validation-errors__field--value
            <!--large-error-->
            ">
                Veuillez contacter le support DYNASSURANCES pour demander une dérogation.
            </div>
        </div>
        <div class="validation-errors__field" v-if="errorsList.errors && isPtcError">
            <div class="validation-errors__field--value">
                {{isPtcError}}
            </div>
        </div>
        <div class="validation-errors__field" v-if="errorsList.errors && isBonusInvalidError">
            <div class="validation-errors__field--value">
                Nous pouvons vous proposer une solution d'assurance pour votre camping-car.<br>
                Merci de contacter directement DYNASSURANCES au 01 48 89 11 58
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ValidationErrors',
        props: {
            errorsList: Object,
            monthly: Boolean
        },
        data() {
            return {
                largeErrors: [
                    'km_reel',
                    'km_jour_vente',
                    'cylindree',
                    'jour_mise_en_circulation',
                    'sale_date',
                    // 'effective_date',
                    'diff_years',
                ],
                hideDerogationErrors: [
                    'adresse',
                    'cp',
                    'email',
                    'nom',
                    'prenom',
                    'tel',
                    'ville',
                    'effective_date',
                    'jour_mise_en_circulation',
                    'diff_years',
                    'name_of_signatory',
                    'error',
                    'power_kw',
                    'puis_fisc',
                ],
                ptcErrors: [
                    'ptc'
                ],
                bonusErrors: [
                    'bonus_invalid'
                ]
            }
        },
        computed: {
            parentComponentName() {
                return this.$parent.$options.name;
            },
            isVehicleErrors() {
                if (!this.errorsList.errors) return false;
                let errorList = Object.keys(this.errorsList.errors);
                for (let error of errorList) {
                    if (!this.hideDerogationErrors.find(item => item === error)) {
                        return true;
                    }
                }
                return false;
            },
            isPtcError() {
                if (!this.errorsList.errors) return false;
                let errorList = Object.keys(this.errorsList.errors);
                for (let error of errorList) {
                    if (this.ptcErrors.find(item => item === error)) {
                        console.log('PTC error');
                        console.log(error);
                        console.log(this.errorsList.errors);
                        if (this.errorsList.errors[error] && Array.isArray(this.errorsList.errors[error])) {
                            return this.errorsList.errors[error][0];
                        }
                        return true;
                    }
                }
                return false;
            },
            isBonusInvalidError() {
                if (!this.errorsList.errors) return false;
                let errorList = Object.keys(this.errorsList.errors);
                for (let error of errorList) {
                    if (this.bonusErrors.find(item => item === error)) return true;
                }
                return false;
            }
        },
        methods: {
            isErrorLarge(key, errors) {
                if (key === 'cylindree' && this.parentComponentName === 'GarantieMoto') return false;
                for (let errorText of errors) {
                    if (errorText.includes('obligatoire') || errorText.includes('cylindrée')) return false;
                }
                return this.largeErrors.includes(key);
            },
            isDealer() {
              return this.$store.getters.isDealer;
            },
          isMutuaide() {
              return this.$store.getters.isMutuaide;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/ValidationErrors.vue